import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/constants/apiRoutes';
import { queryKeys } from 'src/constants/querykeys';
import { MoveProductsRequest, MoveProductsResponse } from 'src/types/favorite';
import axiosInstance from 'src/utils/axios';

export async function moveFavoriteProducts(
  request: MoveProductsRequest
): Promise<MoveProductsResponse> {
  const res = await axiosInstance.post<MoveProductsResponse>(api.moveFavoriteProducts, request);
  return res.data;
}

const useMoveFavoriteProductsMutation = ({
  onSuccess,
  onError,
}: {
  onSuccess?: (data: MoveProductsResponse) => void;
  onError?: (error: Error) => void;
} = {}) => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationKey: queryKeys.favorite.moveFavoriteProducts(),
    mutationFn: moveFavoriteProducts,
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.favorite.root });
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error as Error);
    },
  });

  return mutation;
};

export default useMoveFavoriteProductsMutation;
